/**
 * Returns a list with auxiliaries for the Greek passive voice assessment.
 * @returns {Array}             The list with auxiliaries.
 */
export default [
	"είμαι",
	"είσαι",
	"είναι",
	"είμαστε",
	"είστε",
	"είσαστε",
	"ήμουν",
	"ήσουν",
	"ήταν",
	"ήμαστε",
	"ήμασταν",
	"ήσαστε",
	"ήσασταν",
];
